var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import { Row, Col, AccordionSet } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { FieldRow } from "../FieldRow";
import { AccordionSection } from "../AccordionSection";
import { ExpandCollapseToggle } from "../ExpandCollapseToggle";
import { formatPeriodicalsCount } from "../../utils/formatUtils";
var LibraryDetail = function (_a) {
    var _b, _c, _d;
    var library = _a.library;
    var formatMessage = useIntl().formatMessage;
    var _e = useState({
        general: true,
        legalDeposits: true,
        communication: true,
        dataCollection: true,
    }), accordionStatus = _e[0], setAccordionStatus = _e[1];
    var _f = useState(true), expandAll = _f[0], setExpandAll = _f[1];
    var toggleAccordion = function (section) {
        setAccordionStatus(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[section] = !prevState[section], _a)));
        });
    };
    var toggleExpandCollapseAll = function () {
        setAccordionStatus({
            general: !expandAll,
            legalDeposits: !expandAll,
            communication: !expandAll,
            dataCollection: !expandAll,
        });
        setExpandAll(!expandAll);
    };
    var noAcceptLabel = formatMessage({
        id: "ui-br-legaldeposits.libraries.field.noAccept",
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("h1", null,
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.libraries.detail.pane.title" })),
        React.createElement(ExpandCollapseToggle, { expanded: expandAll, onToggle: toggleExpandCollapseAll }),
        React.createElement(AccordionSet, null,
            React.createElement(AccordionSection, { id: "general-info", labelId: "ui-br-legaldeposits.libraries.accordion.general", open: accordionStatus.general, onToggle: function () { return toggleAccordion("general"); } },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.libraries.field.name", value: library.name })),
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.libraries.field.type", value: library.type
                                ? formatMessage({
                                    id: "ui-br-legaldeposits.libraryType.".concat(library.type),
                                })
                                : "" }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.libraries.field.region", value: (_b = library.region) === null || _b === void 0 ? void 0 : _b.name })))),
            React.createElement(AccordionSection, { id: "legal-deposits-info", labelId: "ui-br-legaldeposits.libraries.accordion.legalDeposits", open: accordionStatus.legalDeposits, onToggle: function () { return toggleAccordion("legalDeposits"); } },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.libraries.field.nonPeriodicalsAllRegions", value: formatPeriodicalsCount(library.nonPeriodicalsCountAllRegions, noAcceptLabel) })),
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.libraries.field.nonPeriodicalsOwnRegion", value: formatPeriodicalsCount(library.nonPeriodicalsCountOwnRegion, noAcceptLabel) }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.libraries.field.periodicals", value: formatPeriodicalsCount(library.periodicalsCount, noAcceptLabel) })),
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.libraries.field.canRequestCopies", value: formatMessage({
                                id: library.canRequestCopies
                                    ? "ui-br-legaldeposits.common.yes"
                                    : "ui-br-legaldeposits.common.no",
                            }) })))),
            React.createElement(AccordionSection, { id: "communication-info", labelId: "ui-br-legaldeposits.libraries.accordion.communication", open: accordionStatus.communication, onToggle: function () { return toggleAccordion("communication"); } },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.libraries.field.correspondenceContact", value: library.correspondenceContact }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.libraries.field.includeReferentInSignature", value: formatMessage({
                                id: library.includeReferentInSignature
                                    ? "ui-br-legaldeposits.common.yes"
                                    : "ui-br-legaldeposits.common.no",
                            }) }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.libraries.field.remindersEnabled", value: formatMessage({
                                id: library.remindersEnabled
                                    ? "ui-br-legaldeposits.common.yes"
                                    : "ui-br-legaldeposits.common.no",
                            }) }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.libraries.field.defaultReminderOffsetDays", value: (_c = library.defaultReminderOffsetDays) === null || _c === void 0 ? void 0 : _c.toString() })),
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.libraries.field.defaultMinGapDays", value: (_d = library.defaultMinGapDays) === null || _d === void 0 ? void 0 : _d.toString() })))),
            React.createElement(AccordionSection, { id: "data-collection-info", labelId: "ui-br-legaldeposits.libraries.accordion.dataCollection", open: accordionStatus.dataCollection, onToggle: function () { return toggleAccordion("dataCollection"); } },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.libraries.field.librarySystem", value: library.librarySystem
                                ? formatMessage({
                                    id: "ui-br-legaldeposits.librarySystem.".concat(library.librarySystem),
                                })
                                : "" }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.libraries.field.oaiUrlMonography", value: library.oaiUrlMonography })))))));
};
export { LibraryDetail };
